import React from 'react'
import { Box } from '@mui/material';

import Navbar from '../../components/Navbar';

const StudentAttendance = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Box sx={{ p: 2 }}>
        StudentAttendance
      </Box>
    </Box>
  )
}

export default StudentAttendance
// // src/pages/StudentAttendance.js
// import React, { useState } from 'react';
// import {
//   Container,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   TextField,
//   Alert,
//   Stepper,
//   Step,
//   StepLabel,
//   StepContent,
//   Chip,
// } from '@mui/material';
// import {
//   QrCodeScanner,
//   LocationOn,
//   Fingerprint,
//   Verified,
// } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { enqueueSnackbar } from 'notistack';
// // import io from 'socket.io-client'; // Uncomment when backend is ready

// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

// const StudentAttendance = () => {
//   const [activeStep, setActiveStep] = useState(0);
//   const [attendanceData, setAttendanceData] = useState({
//     qrData: null,
//     pin: '',
//     locationVerified: false,
//   });
//   const [attendanceSuccess, setAttendanceSuccess] = useState(false);
//   const [studentInfo, setStudentInfo] = useState({
//     name: 'John Doe', // Replace with actual logged-in user data
//     rollNo: '21BCE1234',
//     email: 'john@example.com',
//   });

//   const steps = [
//     {
//       label: 'Scan QR Code',
//       description: 'Scan the QR code displayed by your teacher',
//       icon: <QrCodeScanner />,
//     },
//     {
//       label: 'Enter Security PIN',
//       description: 'Enter the PIN provided by your teacher',
//       icon: <Fingerprint />,
//     },
//     {
//       label: 'Location Verification',
//       description: 'Verify your location within the classroom',
//       icon: <LocationOn />,
//     },
//   ];

//   const handleQRScan = (data) => {
//     try {
//       const qrData = JSON.parse(data);
//       setAttendanceData(prev => ({ ...prev, qrData }));
//       setActiveStep(1);
//       enqueueSnackbar('QR Code scanned successfully!', { variant: 'success' });
//     } catch (error) {
//       enqueueSnackbar('Invalid QR Code', { variant: 'error' });
//     }
//   };

//   const verifyPIN = () => {
//     if (!attendanceData.qrData) {
//       enqueueSnackbar('Please scan QR code first', { variant: 'error' });
//       return;
//     }

//     // Verify PIN matches session code
//     if (attendanceData.pin === attendanceData.qrData.code) {
//       setActiveStep(2);
//       enqueueSnackbar('PIN verified!', { variant: 'success' });
//     } else {
//       enqueueSnackbar('Invalid PIN. Please try again.', { variant: 'error' });
//     }
//   };

//   const verifyLocation = () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setAttendanceData(prev => ({ ...prev, locationVerified: true }));
//           submitAttendance(position.coords);
//         },
//         () => {
//           enqueueSnackbar('Location verification failed', { variant: 'error' });
//         }
//       );
//     } else {
//       enqueueSnackbar('Geolocation not supported', { variant: 'error' });
//     }
//   };

//   const submitAttendance = (coords) => {
//     const attendancePayload = {
//       sessionId: attendanceData.qrData.sessionId,
//       student: {
//         id: Date.now(),
//         name: studentInfo.name,
//         rollNo: studentInfo.rollNo,
//         email: studentInfo.email,
//         timestamp: new Date().toLocaleTimeString(),
//         verified: true,
//         location: {
//           latitude: coords.latitude,
//           longitude: coords.longitude,
//         },
//       },
//     };

//     // PRODUCTION CODE - Uncomment when backend is ready:
//     /*
//     const socket = io('http://your-backend-url:3001');
//     socket.emit('mark-attendance', attendancePayload);
//     socket.on('attendance-marked', (response) => {
//       if (response.success) {
//         setAttendanceSuccess(true);
//         enqueueSnackbar('Attendance marked successfully!', { variant: 'success' });
//       }
//     });
//     */

//     // DEMO CODE - Remove in production
//     setTimeout(() => {
//       setAttendanceSuccess(true);
//       enqueueSnackbar('Attendance marked successfully!', { variant: 'success' });
//     }, 1500);
//   };

//   return (
//     <>
//       <Navbar />
//       <Container maxWidth="md" sx={{ py: 4 }}>
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           <Card>
//             <CardContent sx={{ p: 4 }}>
//               <Box sx={{ textAlign: 'center', mb: 4 }}>
//                 <Typography variant="h3" gutterBottom fontWeight="bold">
//                   Mark Attendance
//                 </Typography>
//                 <Typography variant="h6" color="text.secondary">
//                   Secure attendance system with multi-factor verification
//                 </Typography>
//               </Box>

//               {attendanceSuccess ? (
//                 <Box sx={{ textAlign: 'center', py: 8 }}>
//                   <motion.div
//                     initial={{ scale: 0 }}
//                     animate={{ scale: 1 }}
//                     transition={{ type: "spring", stiffness: 200 }}
//                   >
//                     <Verified sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
//                   </motion.div>
//                   <Typography variant="h4" gutterBottom color="success.main">
//                     Attendance Verified!
//                   </Typography>
//                   <Typography variant="h6" color="text.secondary" gutterBottom>
//                     Your attendance has been successfully recorded
//                   </Typography>
//                   <Chip 
//                     label="SECURE VERIFICATION COMPLETE" 
//                     color="success" 
//                     variant="outlined"
//                     sx={{ mt: 2 }}
//                   />
//                   <Box sx={{ mt: 4 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Recorded at: {new Date().toLocaleTimeString()}
//                     </Typography>
//                   </Box>
//                 </Box>
//               ) : (
//                 <Stepper activeStep={activeStep} orientation="vertical">
//                   {steps.map((step, index) => (
//                     <Step key={step.label}>
//                       <StepLabel StepIconComponent={() => (
//                         <Box sx={{ color: activeStep >= index ? 'primary.main' : 'grey.400' }}>
//                           {step.icon}
//                         </Box>
//                       )}>
//                         <Typography variant="h6">{step.label}</Typography>
//                       </StepLabel>
//                       <StepContent>
//                         <Typography sx={{ mb: 2 }}>{step.description}</Typography>
                        
//                         {index === 0 && (
//                           <Box sx={{ mt: 2 }}>
//                             <Button
//                               variant="contained"
//                               onClick={() => handleQRScan(JSON.stringify({
//                                 sessionId: Date.now(),
//                                 code: 'ABC123',
//                                 location: 'Room 101',
//                                 subject: 'Mathematics'
//                               }))}
//                               startIcon={<QrCodeScanner />}
//                             >
//                               Simulate QR Scan
//                             </Button>
//                             <Alert severity="info" sx={{ mt: 2 }}>
//                               In production, this will open your camera to scan the QR code
//                             </Alert>
//                           </Box>
//                         )}

//                         {index === 1 && (
//                           <Box sx={{ mt: 2 }}>
//                             <TextField
//                               fullWidth
//                               label="Enter Security PIN"
//                               type="text"
//                               value={attendanceData.pin}
//                               onChange={(e) => setAttendanceData(prev => ({ ...prev, pin: e.target.value.toUpperCase() }))}
//                               margin="normal"
//                               placeholder="Enter 6-character code"
//                             />
//                             <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
//                               Demo: Use code "ABC123" to proceed
//                             </Alert>
//                             <Button
//                               variant="contained"
//                               onClick={verifyPIN}
//                               disabled={!attendanceData.pin}
//                               sx={{ mt: 2 }}
//                             >
//                               Verify PIN
//                             </Button>
//                           </Box>
//                         )}

//                         {index === 2 && (
//                           <Box sx={{ mt: 2 }}>
//                             <Alert severity="info" sx={{ mb: 2 }}>
//                               Please allow location access to verify you're in the classroom
//                             </Alert>
//                             <Button
//                               variant="contained"
//                               onClick={verifyLocation}
//                               startIcon={<LocationOn />}
//                             >
//                               Verify Location & Submit
//                             </Button>
//                           </Box>
//                         )}
//                       </StepContent>
//                     </Step>
//                   ))}
//                 </Stepper>
//               )}
//             </CardContent>
//           </Card>
//         </motion.div>
//       </Container>
//       <Footer />
//     </>
//   );
// };

// export default StudentAttendance;